<template>
  <div :class="classes">
    <pt-page-title title="生命体验馆预约参观详情"> </pt-page-title>
    <pt-sub-title title="预约信息"></pt-sub-title>
    <table style="width: 70%">
      <pt-message-table-item label="预约日期" @widthItem="widthItem">
        <span v-if="!isEdit">{{ formatDateToYYYYMMDD(detail.date) }}</span>
        <el-date-picker
          v-if="isEdit"
          v-model="detail.date"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="timestamp"
          :picker-options="pickerOptions"
          @change="changeDate($event)"
        >
        </el-date-picker
      ></pt-message-table-item>
      <pt-message-table-item label="场次">
        <span v-if="!isEdit">{{ detail.time }}</span>
        <el-radio-group v-if="isEdit" v-model="detail.time">
          <el-radio label="上午 10:00-11:00" @change="changeTime(0)"
            >上午 10:00-11:00(剩余{{ residueNum[0] }}人)</el-radio
          >
          <el-radio label="下午 14:00-15:00" @change="changeTime(1)"
            >下午 14:00-15:00(剩余{{ residueNum[1] }}人)</el-radio
          >
        </el-radio-group>
      </pt-message-table-item>
      <pt-message-table-item label="备注信息">
        <span v-if="!isEdit">{{ detail.note }}</span>
        <el-input
          v-if="isEdit"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          resize="none"
          v-model="detail.note"
        >
        </el-input>
      </pt-message-table-item>
      <pt-message-table-item label="用户类型">
        <div>{{ userType }}</div>
         <el-table v-if="detail.userType==='DEPOSITOR'&&!isEdit" :data="tableDataUser" stripe style="width: 100%" class="table-user">
          <el-table-column prop="depositorName" label="姓名"></el-table-column>
          <el-table-column prop="depositorCardId" label="证件号码"></el-table-column>
        </el-table>
      </pt-message-table-item>
      <!-- <el-table :data="tableData" stripe style="width: 100%"></el-table> -->
      <pt-message-table-item label="联系人手机号">
        <span >{{ detail.mobile }}</span>
        <!-- <el-input
          v-if="isEdit"
          v-model="detail.mobile"
          placeholder="请输入手机号"
          style="width: 2.2rem"
        ></el-input> -->
      </pt-message-table-item>
      <pt-message-table-item label="预约人数">
        <span>{{ detail.personCount }}人</span>
        <!-- <el-input
          v-if="isEdit"
          v-model="detail.visitors.length"
          :disabled="true"
          style="width: 2.2rem"
        >
        </el-input> -->
        <template>
          <el-table :data="tableData" stripe style="width: 100%"  class="table-user">
            <el-table-column  label="票种">
              <template slot-scope="scope">
                <span>{{ scope.row.visitorTypeName }} {{ scope.row.priceText }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
                <!-- <el-input
                  v-if="scope.row.isEdit"
                  v-model="scope.row.name"
                ></el-input> -->
              </template>
            </el-table-column>
            <el-table-column prop="identityCardType" label="证件类型">
              <template slot-scope="scope">
                <span>{{
                  replaceIdentityCardType(scope.row.identityCardType)
                }}</span>
                <!-- <el-select
                  v-if="scope.row.isEdit"
                  v-model="scope.row.identityCardType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in identityCardTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> -->
              </template>
            </el-table-column>
            <el-table-column prop="identityCard" label="证件号码">
              <template slot-scope="scope">
                <span>{{
                  scope.row.identityCard
                }}</span>
                <!-- <el-input
                  v-if="scope.row.isEdit"
                  v-model="scope.row.identityCard"
                ></el-input> -->
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号">
              <template slot-scope="scope">
                <span>{{ scope.row.mobile }}</span>
                <!-- <el-input
                  v-if="scope.row.isEdit"
                  v-model="scope.row.mobile"
                ></el-input> -->
              </template>
            </el-table-column>
            <!-- <el-table-column v-if="isEdit" label="操作">
              <template slot-scope="scope">
                <div v-if="!scope.row.isEdit">
                  <el-button type="text" @click="editVisitor(scope.row)"
                    >编辑</el-button
                  >
                  <el-button type="text" @click="remove(scope.row)"
                    >移除</el-button
                  >
                </div>
                <div v-if="scope.row.isEdit">
                  <el-button type="text" @click="cancelEdit(scope.row)"
                    ><span class="iconfont" style="color: #909399"
                      >&#xe732;</span
                    ></el-button
                  >
                  <el-button type="text" @click="finishEdit(scope.row)"
                    ><span class="iconfont">&#xe731;</span></el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- <el-button
            v-if="isEdit && detail.visitors.length < maxPersonCount"
            type="text"
            @click="addVisitor()"
            ><span class="iconfont"
              ><span class="iconfont">&#xe62a;</span>添加一条</span
            ></el-button
          > -->
        </template>
      </pt-message-table-item>
      <pt-message-table-item v-if="!isEdit" label="发起预约时间">{{
        formatDateToYYYYMMDDHHMMSS(detail.createdDate)
      }}</pt-message-table-item>
      <pt-message-table-item v-if="!isEdit" label="状态">
        {{formatStatus(detail.status)}}<span v-if="detail.status==='WAITING_PAYMENT'"> | 剩余支付时间{{ detail.remainderPaymentTime }}</span>
      </pt-message-table-item>
      <pt-message-table-item v-if="!isEdit&&detail.status==='APPROVED'" label="接待部门">
        {{ detail.receiveTypeText }}
      </pt-message-table-item>
      <pt-message-table-item v-if="detail.invoiceStatus" label="发票状态">
        {{ detail.invoiceStatusText }}
      </pt-message-table-item>
      <pt-message-table-item v-if="isFinanceAudit" label="取消类型">
        {{ cancelStatusText }}
      </pt-message-table-item>
    </table>
    <template v-if="detail.paymentDetails&&!isEdit&&detail.paymentDetails.amount">
    <pt-sub-title title="支付信息"></pt-sub-title>
    <div class="payment-message">
      <div class="payment-info">
      <table>
        <pt-message-table-item label="支付金额" :tdMaxWidth="tdMaxWidth">
          {{ detail.paymentDetails.amountShow }}
        </pt-message-table-item>
        <pt-message-table-item label="支付方式"  :tdMaxWidth="tdMaxWidth">
          {{ detail.paymentDetails.channelName }}
        </pt-message-table-item>
        <pt-message-table-item label="支付时间"  :tdMaxWidth="tdMaxWidth">
          {{ detail.paymentDetails.paymentDate }}
        </pt-message-table-item>
        <pt-message-table-item label="支付流水号"  :tdMaxWidth="tdMaxWidth">
          {{ detail.paymentDetails.payNumber }}
        </pt-message-table-item>
      </table>
      </div>
      <table class="refund-info" v-if="detail.refundDetails">
         <pt-message-table-item label="退款状态" :tdMaxWidth="tdMaxWidth">
          {{ detail.refundDetails.statusText }}
        </pt-message-table-item>
         <pt-message-table-item label="退款金额" :tdMaxWidth="tdMaxWidth">
          {{ detail.refundDetails.amountShow }}
        </pt-message-table-item>
         <pt-message-table-item label="退款完成时间" :tdMaxWidth="tdMaxWidth">
          {{ detail.refundDetails.completedTime }}
        </pt-message-table-item>
         <pt-message-table-item label="退款流水号" :tdMaxWidth="tdMaxWidth">
          {{ detail.refundDetails.refundOrderNumber }}
        </pt-message-table-item>
      </table>
    </div>
    </template>
    <div class="toolbar-btn">
      <div v-if="!isEdit">
        <el-button
          type="primary"
          v-if="canEdit"
          @click="editDetail()"
          >编辑</el-button>
        <el-button
          v-if="detail.status === 'WAITING_AUDIT'"
          type="primary"
          plain
          @click="updateStatus('APPROVED')"
          >通过预约</el-button>
          <template v-if="isFinanceAudit">
            <el-button
            v-if="detail.status === 'WAITING_FINANCE_AUDIT'"
            type="primary"
            plain
            @click="financeAuditOfReservation('FINANCE_PASSED')"
            >财务审核通过</el-button>
            <el-button
              v-if="detail.status === 'WAITING_FINANCE_AUDIT'"
              type="primary"
              plain
              @click="financeAuditOfReservation('APPROVED')"
              >财务审核驳回</el-button>
          </template>
        <el-button
          v-if="detail.status === 'WAITING_AUDIT'"
          type="primary"
          plain
          @click="updateStatus('REJECT_CANCEL')"
          >驳回预约</el-button>
        <el-button
          v-if="canCancel"
          type="primary"
          plain
          @click="cancelReservation()"
          >取消预约</el-button>
        <!-- <el-button type="primary" plain @click="backReservations()"
          >返回</el-button> -->
      </div>
      <div v-if="isEdit">
        <el-button type="primary" @click="saveEdit()">保存</el-button>
        <el-button type="primary" plain @click="backDetail()">返回</el-button>
      </div>
    </div>
    <el-dialog :title="'审核'+dialogStatusText" :visible.sync="dialogVisibleOfApprove">
      <span>您本次要{{dialogStatusText}}的预约场次为：<span style="font-weight: bold;">
      {{this.formatDateToYYYYMMDD(this.detail.date)}} {{this.detail.time}}
          {{this.detail.personCount}}人</span>，请确认是否{{dialogStatusText}}？</span>
          <span slot="footer" class="dialog-footer">
            <template v-if="setStatus==='APPROVED'">
            <el-button type="primary" @click="statusConfirm('BUSINESS')">业务部接待</el-button>
            <el-button type="primary" @click="statusConfirm('EXPERIENCE_HALL')">科技馆接待</el-button>
            </template>
            <el-button type="primary" v-else @click="statusConfirm()">确认驳回</el-button>
            <el-button @click="dialogVisibleOfApprove = false">取 消</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
import { cashCount } from '@/utils/formUtils'
import { getChannelName } from 'enumeration/goods-order.js'
import { receiveTypeOptions } from 'cps/appointment-application/pt-life-experience-pavilion-reservation/life-experience-pavilion-reservation'
import timeutils from 'utils/wt-time-utils'
import { getOrderRefundStatus } from 'utils/enumeration/goods-order.js'
import { invoiceStatus } from '../../pt-life-experience-pavilion-invoice/invoice'
const prefixCls = 'pt-reservation-detail'

export default {
  name: 'pt-reservation-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    canEdit () {
      let canEditStatus = ['WAITING_AUDIT', 'APPROVED']
      return canEditStatus.includes(this.detail.status)
    },
    userType () {
      switch (this.detail.userType) {
        case 'NON_DEPOSITOR':
          return '非储户'
        case 'DEPOSITOR':
          return '储户'
        default:
          return '未知'
      }
    },
    canCancel () {
      let canCancelStatus = ['APPROVED']
      return canCancelStatus.includes(this.detail.status)
    },
    cancelStatusText () {
      let cancelStatusText = ''
      switch (this.detail.cancelStatus) {
        case 'TIME_CANCEL':
          cancelStatusText = '场次取消'
          break
        case 'ADMIN_CANCEL':
          cancelStatusText = '管理员取消'
          break
        case 'USER_CANCEL':
          cancelStatusText = '用户取消'
          break
      }
      return cancelStatusText
    }
  },
  data () {
    return {
      identityCardTypeOptions: [
        {
          label: '身份证',
          value: 'CHINESE_IDENTITY_CARD'
        },
        {
          label: '护照',
          value: 'PASSPORT'
        },
        {
          label: '军官证',
          value: 'MILITARY_ID'
        }
      ],
      tableData: [],
      detail: {
        visitors: []
      },
      isEdit: false,
      times: [{}, {}],
      id: '',
      pickerOptions: {
        disabledDate: this.disableDate
      },
      dateArray: [],
      residueNum: [10, 10],
      originDate: '',
      originTime: '',
      originPersonCount: 10,
      maxPersonCount: 10,
      tdMaxWidth: 0,
      tableDataUser: [],
      dialogStatusText: null,
      dialogVisibleOfApprove: false,
      setStatus: null,
      isFinanceAudit: false
    }
  },
  created () {
    this.id = this.$route.params.id
    this.getDetail(this.id)
    this.getReservationDate()
    if (this.$route.query.edit) {
      this.isEdit = true
    }
    if (this.$route.query.isFinanceAudit === 'true') {
      this.isFinanceAudit = true
    }
  },
  mounted () {},
  methods: {
    financeAuditOfReservation (status) {
      let statusText = status === 'FINANCE_PASSED' ? '通过财务审核' : '驳回财务审核'
      this.$confirm(
        `您正在审核退款操作，预约场次为：<span style="font-weight: bold;">${this.formatDateToYYYYMMDD(this.detail.date)} ${this.detail.time} ${this.detail.personCount}人,订单金额为${this.detail.paymentDetails.amountShowDialog}<span style="font-weight: bold;">，请确认是否${statusText}？`,
        {
          confirmButtonText: `确认`,
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        let data = {
          id: this.detail.id,
          status: status
        }
        this.$store.dispatch('financeAuditOfReservation', data).then(res => {
          this.$message({
            type: 'success',
            message: `已${statusText}`
          })
          this.getDetail(this.id)
        }).catch(err => {
          this.$message.error(err || '更新状态失败')
        })
      })
    },
    widthItem (val) {
      this.tdMaxWidth = val
    },
    isOrigin () {
      return (
        this.detail.date === this.originDate
      )
    },
    changeDate (event, init = false) {
      this.$store.dispatch('getReservationTime', { date: event }).then(res => {
        if (init) {
          this.originPersonCount = this.detail.personCount
        }
        if (this.isOrigin()) {
          if (this.originTime.indexOf('上午') !== -1) {
            this.residueNum = [
              res.data[0].residueNum + this.originPersonCount,
              res.data[1].residueNum
            ]
            this.maxPersonCount = this.residueNum[0]
          } else {
            this.residueNum = [
              res.data[0].residueNum,
              res[1].residueNum + this.originPersonCount
            ]
            this.maxPersonCount = this.residueNum[1]
          }
        } else {
          this.residueNum = [res.data[0].residueNum, res.data[1].residueNum]
          if (this.detail.time.indexOf('上午') !== -1) {
            this.maxPersonCount = this.residueNum[0]
          } else {
            this.maxPersonCount = this.residueNum[1]
          }
        }
      })
    },
    getReservationDate () {
      this.$store.dispatch('getReservationDate').then(res => {
        this.dateArray = res.data
      })
    },
    disableDate (time) {
      const dateInArray = this.dateArray.find(
        item => item.date === time.getTime()
      )
      return !dateInArray || !dateInArray.canReservation
    },
    backReservations () {
      this.$router.push('/life-experience-pavilion-reservation')
    },
    editDetail () {
      this.$router.push('/reservation-detail/' + this.id + '?edit=true')
      this.$set(this, 'isEdit', true)
    },
    changeTime (index) {
      this.maxPersonCount = this.residueNum[index]
      this.detail.generalEnumeration = this.times[index]
    },
    saveEdit () {
      let data = {
        id: this.id,
        isUpdate: true,
        mobile: this.detail.mobile,
        personCount: this.detail.personCount,
        time: this.detail.time,
        note: this.detail.note,
        visitors: this.tableData,
        date: this.detail.date,
        generalEnumeration: this.detail.generalEnumeration,
        userType: this.detail.userType
      }
      this.$store
        .dispatch('updateLifeExperienceHallsReservation', data)
        .then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          setTimeout(() => {
            this.backDetail()
          }, 500)
        })
        .catch(err => {
          this.$message.error(err || '保存修改失败')
        })
    },
    backDetail () {
      this.$router.push('/reservation-detail/' + this.id)
      location.reload()
    },
    addVisitor () {
      this.tableData.push({
        name: '',
        identityCardType: '',
        identityCard: '',
        mobile: '',
        isEdit: true
      })
    },
    updateStatus (status) {
      this.dialogStatusText = status === 'APPROVED' ? '通过' : '驳回'
      this.dialogVisibleOfApprove = true
      this.setStatus = status
    },
    statusConfirm (type) {
      let data = {
        id: this.id,
        status: this.setStatus
      }
      if (this.setStatus === 'APPROVED') {
        data.receiveType = type
      }
      this.$store
        .dispatch('updateReservationStatus', data)
        .then(() => {
          this.$message({
            type: 'success',
            message: `已${this.dialogStatusText}`
          })
          setTimeout(() => {
            location.reload()
          }, 500)
          this.dialogVisibleOfApprove = false
        })
        .catch(err => {
          this.dialogVisibleOfApprove = false
          this.$message.error(err || '更新状态失败')
        })
    },
    cancelReservation () {
      this.$confirm('确定取消该预约吗？', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('cancelLifeExperienceHallsReservation', this.id)
          .then(() => {
            this.$message({
              message: '取消成功',
              type: 'success'
            })
            setTimeout(() => {
              this.backDetail()
            }, 500)
          })
          .catch(err => {
            this.$message.error(err || '取消失败')
          })
      })
    },
    cancelEdit (row) {
      if (row.backupData) {
        Object.assign(row, row.backupData)
      } else {
        this.tableData.splice(this.tableData.indexOf(row), 1)
      }
      this.$set(row, 'isEdit', false)
    },
    finishEdit (row) {
      if (this.validateRow(row)) {
        this.$set(row, 'isEdit', false)
      }
    },
    validateRow (row) {
      if (!row.name) {
        this.$message.error('请输入姓名')
        return false
      }
      if (!row.identityCardType) {
        this.$message.error('请选择证件类型')
        return false
      }
      if (!row.identityCard) {
        this.$message.error('请输入证件号码')
        return false
      }
      if (
        row.identityCardType === 'CHINESE_IDENTITY_CARD' &&
        !this.isValidIdentityCard(row.identityCard)
      ) {
        this.$message.error('请输入正确的证件号码')
        return false
      }
      if (!row.mobile) {
        this.$message.error('请输入手机号')
        return false
      }
      if (!this.isValidMobile(row.mobile)) {
        this.$message.error('请输入正确的手机号')
        return false
      }
      return true
    },
    isValidIdentityCard (identityCard) {
      const identityRegexp = /^[1-9]\d{5}(19\d{2}|20\d{2})(0[1-9]|1[0-2])([0-2]\d|30|31)\d{3}[0-9Xx]$/
      return identityRegexp.test(identityCard)
    },
    isValidMobile (mobile) {
      const mobileRegexp = /^1[3456789]\d{9}$/
      return mobileRegexp.test(mobile)
    },
    editVisitor (row) {
      row.backupData = { ...row }
      this.$set(row, 'isEdit', true)
    },
    remove (row) {
      this.tableData.splice(this.tableData.indexOf(row), 1)
    },
    getDetail (id) {
      this.$store
        .dispatch('getLifeExperienceHallsReservationDetail', id)
        .then(res => {
          this.getTimes()
          this.detail = res.data
          this.originDate = this.detail.date
          this.originTime = this.detail.time
          this.changeDate(this.detail.date, true)
          this.tableData = this.detail.visitors.map(visitor => {
            return {
              ...visitor,
              priceText: '¥' + cashCount(visitor.price, true)
            }
          })

          let timeDiff = this.detail.expireTime - new Date().getTime()
          let timeDiffOfMin = timeDiff > 0 ? Math.floor(timeDiff / (1000 * 60)) : null//  剩余时间分钟数
          let timeDiffOfS = timeDiff > 0 ? Math.floor(timeDiff % (1000 * 60) / 1000) : null// 剩余时间秒数
          timeDiffOfMin = timeDiffOfMin && timeDiffOfMin.toString().padStart(2, '0')
          timeDiffOfS = timeDiffOfS && timeDiffOfS.toString().padStart(2, '0')
          this.detail.invoiceStatusText = invoiceStatus[this.detail.invoiceStatus]

          this.detail.receiveTypeText = receiveTypeOptions[this.detail.receiveType]
          this.detail.remainderPaymentTime = timeDiffOfMin ? (`${timeDiffOfMin}:${timeDiffOfS}`) : (`00:${timeDiffOfS}`)
          this.tableDataUser.push({
            depositorName: this.detail.depositorName,
            depositorCardId: this.detail.depositorCardId
          })
          if (this.detail.paymentDetails) {
            this.detail.paymentDetails.amountShow = this.detail.paymentDetails.amount && '¥' + cashCount(this.detail.paymentDetails.amount, true)
            this.detail.paymentDetails.amountShowDialog = this.detail.paymentDetails.amount && '¥' + cashCount(this.detail.paymentDetails.amount, true, 2)
            this.detail.paymentDetails.channelName = this.detail.paymentDetails.channel && getChannelName(this.detail.paymentDetails.channel)
            this.detail.paymentDetails.paymentDate = this.detail.paymentDetails.time && timeutils.format(this.detail.paymentDetails.time)
          }
          if (this.detail.refundDetails) {
            this.detail.refundDetails.statusText = getOrderRefundStatus(this.detail.refundDetails.status)
            this.detail.refundDetails.amountShow = this.detail.refundDetails.refundedAmount && '¥' + cashCount(this.detail.refundDetails.refundedAmount, true)
            this.detail.refundDetails.channelName = this.detail.refundDetails.channel && getChannelName(this.detail.refundDetails.channel)
            this.detail.refundDetails.completedTime = this.detail.refundDetails.completedTime && timeutils.format(this.detail.refundDetails.completedTime)
          }
        }).catch(err => {
          this.$message.error(err || '请求详情失败')
        })
    },
    getTimes () {
      this.$store
        .dispatch('getLifeExperienceHallsReservationTime')
        .then(res => {
          this.times = res
        })
        .catch(err => {
          this.$message.error(err || '请求场次失败')
        })
    },
    formatStatus (status) {
      switch (status) {
        case 'WAITING_AUDIT':
          return '待审核'
        case 'APPROVED':
          return '审核已通过'
        case 'FAILED':
          return '审核未通过'
        case 'CANCEL':
          return '已取消'
        case 'CLOSE_UNPAID':
          return '未支付关闭'
        case 'USER_CANCEL':
          return '用户已取消'
        case 'WAITING_PAYMENT':
          return '待支付'
        case 'REJECT_CANCEL':
          return '审核驳回'
        case 'ADMIN_CANCEL':
          return '管理员取消'
        case 'TIME_CANCEL':
          return '场次取消'
        case 'WAITING_FINANCE_AUDIT':
          return '财务待审核'
        case 'FINANCE_PASSED':
          return '财务审核通过'
        case 'FINANCIAL_AUDIT_FAILED':
          return '财务审核未通过'
        default:
          return '未知状态'
      }
    },
    formatDateToYYYYMMDDHHMMSS (dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatDateToYYYYMMDD (dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    replaceIdentityCardType (type) {
      switch (type) {
        case 'CHINESE_IDENTITY_CARD':
          return '身份证'
        case 'PASSPORT':
          return '护照'
        case 'MILITARY_ID':
          return '军官证'
        default:
          return '未知证件'
      }
    }
  }
}
</script>

<style scoped lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.toolbar-btn {
  margin-top: 30px;
  button {
    margin-right: 30px;
  }
}
.pt-hospital-table {
  :global .iconfont {
    margin-right: 10px;
  }
}
.pt-reservation-detail{
.el-radio-group{
  display: flex;
}
}
.download-qrcode {
  color: #edbe81;
}
.payment-message{
  display: flex;
  .payment-info{
    width: 40%;
  }
}
</style>
